export const EXIT_ACTIONS = {
  BACK: 'back',
  CANCEL: 'cancel',
}

export const EXIT_STEPS = {
  OPEN_DISCARD_MODAL: 'openDiscardModal',
  OPEN_MOBILE_PROFILE: 'openMobileProfile',
  GO_TO_PREVIOUS_PAGE: 'goToPreviousPage',
  STAY: 'stay',
}

// React Router asigna la key 'default' a la primera entrada del historial de la app
const INITIAL_LOCATION_KEY = 'default'

/**
 * Destino de "página anterior" para `navigate`.
 *
 * Si Mi perfil fue la primera página cargada (URL directa o recarga) no hay historial
 * dentro del shell, por lo que se envía al inicio en vez de salir de la app.
 *
 * @param {string} locationKey - `location.key` de React Router
 * @returns {number|string} `-1` para volver en el historial o `'/'` como fallback
 */
export function getPreviousPageTarget(locationKey) {
  return locationKey === INITIAL_LOCATION_KEY ? '/' : -1
}

/**
 * Resuelve qué hacer al presionar Volver o Cancelar en Mi perfil (PBI 84325).
 *
 * @param {Object} params
 * @param {string} params.action - `EXIT_ACTIONS.BACK` | `EXIT_ACTIONS.CANCEL`
 * @param {boolean} params.hasChanges - Hay cambios sin guardar
 * @param {boolean} [params.canOpenMobileProfile] - En mobile, Volver reabre el menú de perfil
 * @returns {string} Uno de `EXIT_STEPS`
 */
export function resolveExitStep({ action, hasChanges, canOpenMobileProfile = false }) {
  if (hasChanges) return EXIT_STEPS.OPEN_DISCARD_MODAL
  if (action === EXIT_ACTIONS.BACK && canOpenMobileProfile) return EXIT_STEPS.OPEN_MOBILE_PROFILE

  return EXIT_STEPS.GO_TO_PREVIOUS_PAGE
}

/**
 * Resuelve qué hacer después de confirmar "Descartar cambios".
 *
 * Solo sale de Mi perfil cuando el modal se abrió desde Volver; desde Cancelar se
 * queda en la pantalla con los valores originales.
 *
 * @param {Object} params
 * @param {string|null} params.action - Botón que abrió el modal
 * @param {boolean} [params.canOpenMobileProfile]
 * @returns {string} Uno de `EXIT_STEPS`
 */
export function resolveDiscardStep({ action, canOpenMobileProfile = false }) {
  if (action !== EXIT_ACTIONS.BACK) return EXIT_STEPS.STAY

  return resolveExitStep({ action, hasChanges: false, canOpenMobileProfile })
}
